import React from "react";

const Home: React.FC = () => {
  return (
    <div>
      <h1>Welcome to th e Home Page</h1>
    </div>
  );
};

export default Home;
